import { validatePresenceOf } from '@/shared/utils';

export const validate = (sie, options) => {
  return validatePresenceOf(
    sie,
    ['place', 'date', 'fileType', 'fileNumber', 'referenceType', 'referenceNumber'],
    options
  );
};
